import { Box, Tab, TabList, TabPanel, TabPanels, Tabs } from '@tonic-one/react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import ActionNotification from '@Policy/AdvancedThreatProtection/PolicyTemplate/Filters/VirtualAnalyzer/ActionNotification';
import Rules from '@Policy/AdvancedThreatProtection/PolicyTemplate/Filters/VirtualAnalyzer/Rules';

const VirtualAnalyzer = () => {
  const { t } = useTranslation();
  return (
    <Box>
      <Tabs>
        <TabList>
          <Tab>{t('policy.rules')}</Tab>
          <Tab>{t('policy.actionAndNotification')}</Tab>
        </TabList>
        <TabPanels py="2x">
          <TabPanel>
            <Rules
              applyBoundShow={false}
              tempQuarantineShow={false}
              monitorModeShow={true}
            />
          </TabPanel>
          <TabPanel>
            <ActionNotification advancedOptionShow={false} />
          </TabPanel>
        </TabPanels>
      </Tabs>
    </Box>
  );
};
export default React.memo(VirtualAnalyzer);
